/**
 * Consulta CNPJ via backend (cadeia BrasilAPI → cnpj.ws → ReceitaWS + cache 30d).
 * Consulta CEP via ViaCEP (direto no cliente — segue como antes).
 *
 * LOTE CN-1: não falha em silêncio.
 *   Retorna { status, source, situacao, data } sempre.
 *   status ∈ "ok" | "invalid" | "not_found" | "situacao_alerta" | "unavailable"
 */

import api from "@/lib/api";

export async function fetchCNPJ(cnpj) {
  const digits = (cnpj || "").replace(/\D/g, "");
  if (!digits) {
    return { status: "invalid", source: null, situacao: null, data: null };
  }
  try {
    const { data } = await api.get(`/cnpj/${digits}`);
    return {
      status: data?.status || "unavailable",
      source: data?.source || null,
      situacao: data?.situacao || null,
      data: data?.data || null,
    };
  } catch {
    return { status: "unavailable", source: null, situacao: null, data: null };
  }
}

export async function fetchCEP(cep) {
  const d = (cep || "").replace(/\D/g, "");
  if (d.length !== 8) return null;
  try {
    const r = await fetch(`https://viacep.com.br/ws/${d}/json/`);
    if (!r.ok) return null;
    const j = await r.json();
    if (j?.erro) return null;
    return {
      logradouro: j.logradouro || "",
      bairro: j.bairro || "",
      cidade: j.localidade || "",
      estado: (j.uf || "").toUpperCase(),
    };
  } catch {
    return null;
  }
}
